import { IZipCodeRangeChecker } from '@shared/rangeChecker/IZipCodeRangeChecker';

export class NumericalZipCodeRangeChecker implements IZipCodeRangeChecker {
	from: number;
	to: number;
	public constructor(from: number, to: number) {
		this.from = from;
		this.to = to;
	}

	public IsValidRange(): boolean {
		return !Number.isNaN(this.from) && !Number.isNaN(this.to) && this.from <= this.to;
	}

	public doesRangeOverlap(from: string, to: string): boolean {
		const fromVal = Number.parseInt(from, 10);
		const toVal = Number.parseInt(to, 10);

		if (Number.isNaN(fromVal) || Number.isNaN(toVal)) {
			return false;
		}

		const fromCheck = this.from <= fromVal && this.to >= fromVal;
		const toCheck = this.from <= toVal && this.to >= toVal;

		return fromCheck || toCheck;
	}
}
